// extracted by mini-css-extract-plugin
export default {"submenuPopup":"O6ZfvrJ5bvRcPbJ4yNVM","submenuArrow":"QeX2zRNWo8uiR7rUDT4P"};